<template>
  <div class="qcCheckList">
    <el-table stripe border style="width: 100%" height="100%" size="mini"
          :data="tableData" @sort-change="sortChange"
        >
          <el-table-column type="index" align="center"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            label="检验单号" width="130px" align="center" prop="number" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.orderNumber }}
              </span>
            </template>
          </el-table-column>
          <el-table-column min-width="50px" 
            label="送检数量" prop="batchQuantity" align="center" show-overflow-tooltip 
          >
            <template slot-scope="scope">
              <span v-if="scope.row.batchQuantity">
                {{ scope.row.batchQuantity }} PCS
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column min-width="50px" 
            label="累计数量" prop="countQuantity" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.countQuantity">
                {{ scope.row.countQuantity }} PCS
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column max-width="110px" 
            label="送检时间" prop="startDateTime" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.createDateTime">
                {{ scope.row.createDateTime }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>          
          <el-table-column
            label="送检人" prop="name" align="center" show-overflow-tooltip
            width="135px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.createUser">
                {{ scope.row.createUser.name }}({{ scope.row.createUser.employeeNum }})
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column min-width="60px" 
            label="检验批次" prop="checkNumber" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.checkDateTime" class="item expire" effect="dark" placement="top" :open-delay="300"
               :content="scope.row.checkDateTime">
                <span>
                  {{ scope.row.partLot }} 
                </span>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="检验人" prop="name" align="center" show-overflow-tooltip
            width="135px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.checkUser">
                {{ scope.row.checkUser.name }}({{ scope.row.checkUser.employeeNum }})
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column min-width="40px" 
            label="状态" prop="status" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.status && scope.row.status.code>0" class="item expire" effect="dark" placement="top" :open-delay="300"
                :class="scope.row.status.code==2 ? 'tiaojian' : 'fail'">
                  <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ scope.row.failedRecordResultList.length>0 ? JSON.stringify(scope.row.failedRecordResultList, null, 2) : 'QC判退' }}</div>
                  <span v-if="scope.row.status">
                    <i v-if="scope.row.status.code==2" class="el-icon-check1"></i>
                    <i v-else class="el-icon-close"></i>{{ scope.row.status.title }} 
                  </span>
                  <span v-else>-</span>
              </el-tooltip>
                <span v-else-if="scope.row.status" :class="scope.row.status.code==0 ? 'pass_' : ''">
                  <i v-if="scope.row.status.code==0" class="el-icon-check1"></i>{{ scope.row.status.title }} 
                </span>
                <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column max-width="100px" 
            label="入库时间" prop="storageDateTime" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.storageDateTime">
                {{ scope.row.storageDateTime }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getQcCheckListSearch"
        ></pagination>
    <myDialog ref="myDialog" width="680px"
      :title="'送检单号'" @dialogClose="dialogClose"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="送检单号" size="small" class="inlineItem">
            <el-input v-model="dialogForm.number" :readonly="true"/>
          </el-form-item>
          <el-form-item label="送检数量" size="small" class="inlineItem">
            <el-input v-model="dialogForm.batchQuantity"/>
          </el-form-item>
          <el-form-item label="送检人" size="small" class="inlineItem">
            <el-input v-model="dialogForm.user.name" :readonly="true"/>
          </el-form-item>

          <el-form-item label="送检设备SN" size="small">
            <el-input  v-model="dialogForm.sns"  type="textarea" rows="30" />
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiQcCheckListDelete,
  apiQcCheckListSearch,
  apiQcOrderExport,
  apiQCCheckSNExport,
} from "@/api/qcOrder.js";
export default {
  components: {
    pagination,
    myDialog,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    inspectionForm: {
      type: Object,
    },
  },
  data() {
    return {
      isMoreSearch: false,
      tabPaneList: [],
      tabPaneData: {},
      searchConditionForm: {},
      pullDownData: {
        customerList:[],
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {
        productionOrder:{},
        user:{},
      },
      dialogRules: {
        
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },

  methods: {
    deleteOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "删除", "检验单").then(
        async () => {
          const res = await apiQcCheckListDelete({
            id: row.id,
          });
          if (res.code == 0) {
            this.getQcCheckListSearch();                
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },

    // 点击表格编号
    clickAllowSkip(row) {
      row
    },

    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      // this.dialogForm = {
      // };
    },
    // 查询条件--开始日期
    startDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].endDate = this[formName].startDate;
      }
    },
    // 查询条件--结束日期
    endDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].startDate = this[formName].endDate;
      }
    },    
    // 表格数据
    async getQcCheckListSearch(remove, callback) {
      const res = await apiQcCheckListSearch({
        productionOrderId: this.tabPaneValue,
        ...this.inspectionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        
      }
      if (callback) callback();
    },

    // 确认查询
    onSearch() {
      if(this.tabPaneValue == "first" && this.twoTabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.getQcCheckListSearch();
      }else if(this.tabPaneValue == "first" && this.twoTabPaneValue != "first"){
        this.$refs.detailPage.detail();
        this.$refs.detailPage.detailSn();
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getQcCheckListSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getQcCheckListSearch();
    },    
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getQcCheckListSearch();
    },    
    callback() {
      this.getCustomerList();
    },
    //检验单记录导出
    QCOrderExport(command) {

      this.$confirm(`请勿频繁导出！`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        if(command=="检验单记录明细"){
          const res = await apiQcOrderExport({
          productionOrderId: this.tabPaneValue,
          ...this.inspectionForm,
          export: true,
          });
          if (res.code == 0) {
            this.$downloadFile(res.fid, res.fileName, res.secretKey);
          }
        }
        if(command=="抽检SN记录明细"){
          const res = await apiQCCheckSNExport({
          productionOrderId: this.tabPaneValue,
          type:"FQC",
          ...this.inspectionForm,
          export: true,
          });
          if (res.code == 0) {
            this.$downloadFile(res.fid, res.fileName, res.secretKey);
          }
        }
        
      })
      }
    
  },
};
</script>

<style lang="less" scoped>
.none_border {width:265px; margin: left 2px;; display: -moz-inline-box; display: inline-block;}
.qcCheckList {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.item {
  margin-right: 2px;
  margin-left: 2px;
}
  .pass_{
    color:#67C23A;
  }
  .tiaojian {
    color: #e6a23c;
  }
  .fail {
    color: #f56c6c;
  }
</style>
